import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { ElementTransactionType } from "./ElementsService";
setupInterceptorsTo(axios);
interface IElementsPromotion
{
    id?: number,
    name: string,
    description: string,
    amountType: string,
    amountElement: number,
    slug: string,
    active: boolean,
    elementsButton: string,
    startDate: string,
    endDate: string,
    elementTransaction: ElementTransactionType,
    parent: IElementsPromotion,
    childrens: IElementsPromotion[]
}

export type ElementsPromotionType = IElementsPromotion;

class ElementsPromotionsService
{
    public getElementsPromotions = async (): Promise<ElementsPromotionType[]> =>
    {
        let url: string = `${proxyUrl}/elementsPromotions`;
        const req = await axios.get(url);
        return req.data;
    }
    public getActiveElementsPromotions = async (): Promise<ElementsPromotionType[]> =>
    {
        let url: string = `${proxyUrl}/elementsPromotions?active=true`;
        const req = await axios.get(url);
        return req.data;
    }
    public getElementsPromotionsAppliedToSavingsPlan = async (savingsPlanId: number): Promise<ElementsPromotionType[]> =>
    {
        let url: string = `${proxyUrl}/elementsPromotions/getAppliedToSavingsPlan/${savingsPlanId}`;
        const req = await axios.get(url);
        return req.data;
    }
    public getElementsPromotionsAvailableForSavingsPlan = async (savingsPlanId: number): Promise<ElementsPromotionType[]> =>
    {
        let url: string = `${proxyUrl}/elementsPromotions/getAvailableForSavingsPlan/${savingsPlanId}`;
        const req = await axios.get(url);
        return req.data;
    }
    public getElementsPromotion = async (elementsPromotionId: number): Promise<ElementsPromotionType> =>
    {
        let url: string = `${proxyUrl}/elementsPromotions/${elementsPromotionId}`;
        const req = await axios.get<any>(url);
        return req.data;
    }
    // Las promociones de Elements son de solo lectura (auditoría de seguridad G2-16): el backend ya no admite POST, PUT, PATCH ni DELETE
}

const elementsPromotions = new ElementsPromotionsService();
export default elementsPromotions;